<template>
    <div :class="boxMsgStyle" class="box-msg last-box-msg">
      <div ref="icon_bot" class="bot-icon" v-if="!isUserSend">
        <img :src="styles.avatarBot" alt="robot" style="max-width:24px;max-height:24px;">
      </div>
      <div :style="customUI" class="msg-1">
        <div class="typing-spinner">
            <div class="dot" v-for="n in 3" :key="n"></div>
        </div>
      </div>
    </div>
</template>
  
  <script>
  
  import BaseBox from "@/components/ChatBoxElement/BaseBox";

  export default {
    name: 'ChatTyping',
    extends: BaseBox
  };
  </script>
  
  <style scoped>
  .typing-spinner {
    display: flex;
    justify-content: space-between;
    width: 36px;
  }
  
  .dot {
    width: 8px;
    height: 8px;
    background-color: #fff;
    border-radius: 50%;
    animation: blink 1.4s infinite both;
  }
  
  .dot:nth-child(1) {
    animation-delay: -0.32s;
  }
  
  .dot:nth-child(2) {
    animation-delay: -0.16s;
  }

  .bot-icon {
      width           : 40px;
      height          : 50px;
      float           : left;
      background-size : 32px;
  }
  
  @keyframes blink {
    0%, 80%, 100% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
  }
  </style>
  